import PropTypes from 'prop-types';
import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import reqwest from 'reqwest';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import settings from '../../constants/settings';
import Fetch from '../../components/Fetch';

import { addOrt } from '../../actions/actions';

class AddOrt extends React.Component {
  constructor() {
    super();
    this.state = {
      search: '',
      redirect: false,
      initializeMap: false,
    };
    this.map = null;
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.state.initializeMap === true && prevState.initializeMap === false) {
      this.initializeMap();
    }
  }
  initializeMap = () => {
    this.map = new google.maps.Map(this.mapContainer, {
      zoom: 6,
      center: { lat: 51.035029, lng: 10.294575 },
    });
    this.geocoder = new google.maps.Geocoder();
    google.maps.event.addListener(this.map, 'click', e => {
      const lat = e.latLng.lat().toFixed(6);
      const lng = e.latLng.lng().toFixed(6);
      const position = new google.maps.LatLng(lat, lng);
      this.geocoder.geocode(
        {
          latLng: e.latLng,
        },
        (results, status) => {
          if (status === google.maps.GeocoderStatus.OK) {
            const result = results[0].address_components.filter(item =>
              item.types.includes('locality'),
            );
            const name = result[0].long_name;
            this.setState({
              selectedPlace: {
                ...this.state.selectedPlace,
                name,
              },
            });
          } else {
            this.setState({
              selectedPlace: {},
            });
          }
        },
      );
      if (!this.marker) {
        this.marker = new google.maps.Marker({
          position,
          map: this.map,
        });
        this.map.panTo(position);
      } else {
        this.marker.setPosition(position);
        this.map.panTo(position);
      }
      this.setState({
        selectedPlace: {
          ...this.state.selectedPlace,
          lat,
          lng,
        },
      });
    });
    this.setState({
      initializeMap: false,
    });
  };
  switchTabs = index => {
    if (index === 1 && !this.state.initializeMap) {
      this.setState({
        initializeMap: true,
      });
    } else {
      this.marker = null;
      this.map = null;
      this.setState({
        initializeMap: false,
        selectedPlace: null,
      });
    }
  };
  addOrt = (name, id) => {
    reqwest({
      url: settings.LAT_LNG_URL,
      data: {
        id,
      },
      method: 'GET',
      crossOrigin: true,
    }).then(data => {
      this.props.addOrt(name, data.latitude, data.longitude);
      this.setState({
        redirect: '/orte',
      });
    });
  };
  addSelectedPlace = () => {
    this.props.addOrt(
      this.state.selectedPlace.name,
      this.state.selectedPlace.lat,
      this.state.selectedPlace.lng,
    );
    this.setState({
      redirect: '/orte',
    });
  };
  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }
    return (
      <div className="AddOrt">
        <Tabs onSelect={this.switchTabs}>
          <TabList className="Tabs">
            <Tab className="Tabs-tab" selectedClassName="is-selected">
              Liste
            </Tab>
            <Tab className="Tabs-tab" selectedClassName="is-selected">
              Karte
            </Tab>
          </TabList>
          <TabPanel>
            <input
              type="text"
              name="search"
              placeholder="Ortsnamen oder PLZ eingeben..."
              onChange={e => {
                this.setState({
                  search: e.target.value,
                });
              }}
            />
            {this.state.search.length > 2 && (
              <Fetch
                url={settings.LANDKREISE_URL}
                method="GET"
                data={{ search: this.state.search, token: localStorage.getItem('uuid') }}
              >
                {({ areas, ids }) => {
                  if (areas && areas.length) {
                    return (
                      <ul className="AreaList">
                        {areas.map((area, index) => (
                          <li className="AreaList-item" key={area}>
                            <button
                              className="AreaList-link"
                              onClick={() => this.addOrt(area, ids[index])}
                            >
                              {area}
                            </button>
                          </li>
                        ))}
                      </ul>
                    );
                  }
                  return null;
                }}
              </Fetch>
            )}
          </TabPanel>
          <TabPanel>
            <div
              className={`Map-wrapper ${
                this.state.selectedPlace && this.state.selectedPlace.name ? 'hasPlaceSelected' : ''
              }`}
            >
              <div
                className="Map"
                ref={node => {
                  this.mapContainer = node;
                }}
              />
              {this.state.selectedPlace &&
                this.state.selectedPlace.name && (
                  <button className="Map-selectButton" onClick={this.addSelectedPlace}>
                    Ort auswählen
                  </button>
                )}
            </div>
          </TabPanel>
        </Tabs>
      </div>
    );
  }
}

AddOrt.propTypes = {
  addOrt: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  addOrt: (name, lat, lng) => {
    dispatch(addOrt(name, lat, lng));
  },
});

export default connect(null, mapDispatchToProps)(AddOrt);



// WEBPACK FOOTER //
// ./src/js/routes/Orte/AddOrt.js